import React, { useContext } from "react";
import UswfButton from "./UswfButton";
import { Link } from "@mui/material";
import { NavigationContext } from "../../context/NavigationContext";

const SubmitButton = (props) => {
  const context = useContext(NavigationContext);
  const onSubmit = !!props.customSubmit ? props.customSubmit : context.onSubmit;

  return (
    <div className="next-button-wrapper">
      <Link
        className="navigation-link"
        onClick={() => (props.canSubmit ? onSubmit() : null)}
      >
        <UswfButton disabled={!props.canSubmit}>
          <label className="submit-label">
            {props.label ? props.label : "Next"}
          </label>
        </UswfButton>
      </Link>
    </div>
  );
};

export default SubmitButton;
